import {v4 as uuidv4} from 'uuid';
import {SeriesNoticeV2Vo} from '../../common/shared/api/nicolas/vo/SeriesNoticeV2Vo.interface';
import {SeriesNotice} from '../generated/types';
import {createSeriesNoticeType} from './SeriesNoticeType';

export function createSeriesNotice({
  create_dt,
  description,
  exposure,
  modify_dt,
  n_type,
  publisher_uid,
  series_id,
  series_title,
  system_notice,
  title,
  uid,
}: SeriesNoticeV2Vo): SeriesNotice {
  return {
    id: uuidv4(),
    seriesId: series_id,
    uid,
    createDate: create_dt,
    description,
    isExposure: exposure !== false, // false 혹은 null로만 오기 때문에 false가 아니면 보여줍니다
    isSystemNotice: system_notice,
    modifyDate: modify_dt,
    noticeType: createSeriesNoticeType(n_type),
    publisherUid: publisher_uid,
    seriesTitle: series_title,
    title,
  };
}
